// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: eJaBS3SEf6
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicExamTimer.module.css"; // plasmic-import: eJaBS3SEf6/css
import Icon10Icon from "./icons/PlasmicIcon__Icon10"; // plasmic-import: iObu3_zlGi/icon

createPlasmicElementProxy;

export const PlasmicExamTimer__VariantProps = new Array("status");

export const PlasmicExamTimer__ArgProps = new Array();

const $$ = {};

function PlasmicExamTimer__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.status
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxstatus_average]: hasVariant($state, "status", "average"),
          [sty.freeBoxstatus_bad]: hasVariant($state, "status", "bad"),
          [sty.freeBoxstatus_good]: hasVariant($state, "status", "good")
        })}
      >
        <Icon10Icon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg, {
            [sty.svgstatus_average]: hasVariant($state, "status", "average"),
            [sty.svgstatus_bad]: hasVariant($state, "status", "bad"),
            [sty.svgstatus_good]: hasVariant($state, "status", "good")
          })}
          role={"img"}
        />

        <div
          data-plasmic-name={"timer"}
          data-plasmic-override={overrides.timer}
          className={classNames(projectcss.all, sty.timer)}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "svg", "timer"],
  freeBox: ["freeBox", "svg", "timer"],
  svg: ["svg"],
  timer: ["timer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicExamTimer__ArgProps,
          internalVariantPropNames: PlasmicExamTimer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicExamTimer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicExamTimer";
  } else {
    func.displayName = `PlasmicExamTimer.${nodeName}`;
  }
  return func;
}

export const PlasmicExamTimer = Object.assign(
  // Top-level PlasmicExamTimer renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    svg: makeNodeComponent("svg"),
    timer: makeNodeComponent("timer"),
    // Metadata about props expected for PlasmicExamTimer
    internalVariantProps: PlasmicExamTimer__VariantProps,
    internalArgProps: PlasmicExamTimer__ArgProps
  }
);

export default PlasmicExamTimer;
/* prettier-ignore-end */
